module.exports = __webpack_public_path__ + "img/tms_shengxin.ce0821a3.png";